import { Pipe, PipeTransform } from '@angular/core';
import { ValetAnomalyService } from 'src/app/valet/services/valet-anomaly.service';

@Pipe({
    name: 'anomalyTypeFormat',
    pure: true,
    standalone: false
})
export class AnomalyTypeFormatPipe implements PipeTransform {
  constructor(private valetAnomalyService: ValetAnomalyService) {}

  transform(row: any, ...args: unknown[]): string {
    return this.valetAnomalyService.anomalyTypesGroups.flatMap(g => g.types).find(t => t.value === row.type)?.name || '';
  }
}